import { useState } from "react";

import {
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardHeader,
  CCollapse,
  CTooltip,
} from "@coreui/react";
import { formatUTCDateTime } from "../../utils/dates";
import { formatToCurrency } from "../../currency/format";
import { CURRENCY_CHOICES } from "../../currency/available-currencies";
import ReceivedInvoiceCrudActions from "./ReceivedInvoiceCrudActions";
import PermissionRequiredComponent from "../permissions/PermissionRequiredComponent";
import { INVOICES_RETRIEVE } from "../../auth/permissions";
import {
  formatReceivedInvoiceNumber,
  ReceivedInvoice,
} from "../../models/received-invoice";

interface ReceivedInvoiceCardProps {
  invoice: ReceivedInvoice;
  onPDFClick: (inv: ReceivedInvoice) => void;
  onReadClick: (inv: ReceivedInvoice) => void;
  onUpdateClick: (inv: ReceivedInvoice) => void;
  onDeleteClick: (inv: ReceivedInvoice) => void;
}

export function ReceivedInvoiceCard({
  invoice,
  onPDFClick,
  onReadClick,
  onUpdateClick,
  onDeleteClick,
}: ReceivedInvoiceCardProps) {
  const [open, setOpen] = useState(true);

  let pdfButton = null;

  if (invoice.pdfPath !== undefined) {
    pdfButton = (
      <PermissionRequiredComponent permissionName={INVOICES_RETRIEVE}>
        <CTooltip content="PDF">
          <CButton
            className="text-white"
            color="danger"
            onClick={() => {
              onPDFClick(invoice);
            }}
          >
            <i className="fa fa-file"></i>
          </CButton>
        </CTooltip>
      </PermissionRequiredComponent>
    );
  }

  return (
    <CCard className="mb-2">
      <CCardHeader
        className="d-flex justify-content-between align-items-center cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <span>
          <strong>{formatReceivedInvoiceNumber(invoice)}</strong>
        </span>
        <span className="d-flex align-items-center gap-2">
          <strong>{formatUTCDateTime(new Date(invoice.invoiceDate!))}</strong>
          <span
            className="rounded-circle bg-white d-flex justify-content-center align-items-center ml-1"
            style={{ width: "22px", height: "22px" }}
          >
            <i
              className={`fa fa-chevron-${open ? "up" : "down"}`}
              style={{ color: "black", fontSize: "12px" }}
            />
          </span>
        </span>
      </CCardHeader>
      <CCollapse show={open}>
        <CCardBody>
          <p>
            <strong>Razón Social:</strong> {invoice.supplierSocialName}
          </p>
          <p>
            <strong>RUC:</strong> {invoice.supplierRuc}
          </p>
          <p>
            <strong>Monto:</strong>{" "}
            {formatToCurrency(invoice.amount!, invoice.currency!)}
          </p>
          <p>
            <strong>Moneda:</strong> {CURRENCY_CHOICES.get(invoice.currency!)}
          </p>

          <div>
            <strong>Archivos:</strong>{" "}
            <td className="text-center">
              <CButtonGroup>{pdfButton}</CButtonGroup>
            </td>
          </div>
          <div>
            <strong>Acciones disponibles:</strong>{" "}
            <ReceivedInvoiceCrudActions
              invoice={invoice}
              onReadClick={onReadClick}
              onUpdateClick={onUpdateClick}
              onDeleteClick={onDeleteClick}
            />
          </div>
        </CCardBody>
      </CCollapse>
    </CCard>
  );
}
